module.exports = __webpack_public_path__ + "img/view-icon-white.1e45d4f5.svg";